import { DateTime as DT } from 'luxon';
import { useSettings } from 'context/SettingsContext';
import { ObjectStatusIcon } from 'modules/objects';
import type { UserIncomeReportItemType } from '@econtractor/types';
import { formatIncomeLocal, formatIncomePrimary } from '../../model';

interface UserIncomeRowsTableRowProps {
    row: UserIncomeReportItemType;
}

const UserIncomeRowsTableRow = ({ row }: UserIncomeRowsTableRowProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;
    const date = DT.fromMillis(row.dt || 0).toFormat('dd.MM.yyyy');
    const amount = Number(row.amount) || 0;
    const amountRate = Number(row.amountRate) || 0;

    return (
        <tr>
            <td className="name">
                <div className="d-flex align-items-center gap-2 min-w-0">
                    <span className="flex-shrink-0">
                        <ObjectStatusIcon status={row.objectStatus} />
                    </span>
                    <h6 className="mb-0 text-break">{row.objectName || '—'}</h6>
                </div>
            </td>
            <td className="service">
                <span className="text-break">{row.serviceName || '—'}</span>
            </td>
            <td className="date">{date}</td>
            <td className="income text-end">
                <h6 className="mb-1 text-break">{formatIncomePrimary(amount, rate)}</h6>
                {!isUahMode && (
                    <p className="text-muted f-12 mb-0 my-1">{formatIncomeLocal(amountRate)}</p>
                )}
            </td>
        </tr>
    );
};

export default UserIncomeRowsTableRow;
